import './EntityProjects.css';
import { useContext } from "react";
import Page1 from "./pages/Page1";
import Page2 from "./pages/Page2";
import EntityProjectsContext from "./context/EntityProjects.context";

import { useSelector } from 'react-redux';

const EntityProjects = () => {
  const { pageToRender } = useContext(EntityProjectsContext);

  const sessionSelector = useSelector((state) => { return state.core.session });

  if (pageToRender === 'goback') {
    return <Page1 />
  }

  if (sessionSelector.pdc_project_friendly_url) {
    return <Page2 />
  }

  return pageToRender === 1 ? <Page1 /> : <Page2 />
};

export default EntityProjects;
